import { Tooltip, IconButton } from "@mui/material"
import { useColorScheme } from '@mui/material/styles';
import { useEffect, useCallback } from "react"
import LightModeIcon from "@mui/icons-material/LightMode"
import DarkModeIcon from "@mui/icons-material/DarkMode"
import { tooltip } from "../../../helpers/tooltip.utils";
import { useRecoilState } from "recoil";
import { themeAtom } from "../../../recoil/atoms";



export enum EThemeMode {
  Dark = 'dark',
  Light = 'light'
}

const ThemeToggle = () => {

  const [theme, setTheme] = useRecoilState(themeAtom)
  const scheme = useColorScheme()

  const setDarkMode = () => {
    setTheme(EThemeMode.Dark)
    scheme.setMode(EThemeMode.Dark)
  }

  const setLightMode = () => {
    setTheme(EThemeMode.Light)
    scheme.setMode(EThemeMode.Light)
  }

  useEffect(() => {
    theme === EThemeMode.Dark ? setDarkMode() : setLightMode()
  }, [])

  const onToggle = useCallback(() => {
    scheme.mode === EThemeMode.Dark ? setLightMode() : setDarkMode()
  }, [scheme.mode])


  if (!scheme.mode) {
    return null
  }

  return (
    <Tooltip title={tooltip.theme}>
      <IconButton onClick={onToggle}>{scheme.mode === 'dark' ? <DarkModeIcon /> : <LightModeIcon />}</IconButton>
    </Tooltip>
  )
}
export default ThemeToggle